<div [class]="'loading-skeleton ' + skeletonType"></div>
